import React from 'react';
import { styles } from './QuickSearch.css';
import { SearchIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Search';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { SearchTooltip } from '../../../SearchTooltip/SearchTooltip';
import { useSearchTooltip } from '../../../SearchTooltip/useSearchTooltip';
import { useSearchTooltipConfig } from '../../../SearchTooltip/useSearchTooltipConfig';
import type { SearchTooltipConfig } from '../../../SearchTooltip/useSearchTooltipConfig';
import { useRotatingPlaceholder } from '../../../SearchTooltip/useRotatingPlaceholder';

export interface QuickSearchProps {
  placeholder?: string;
  className?: string;
  searchTooltipConfig?: SearchTooltipConfig;
}

export const QuickSearch = ({ placeholder, className, searchTooltipConfig }: QuickSearchProps) => {
  const {
    shouldShowTooltip,
    tooltipTitle,
    tooltipBody,
    enabled: isTooltipEnabled,
    normalizedPlaceholders,
    dismissDelay,
  } =
    useSearchTooltipConfig(searchTooltipConfig);
  const shouldShowTooltipNow = useSearchTooltip(shouldShowTooltip, dismissDelay);
  const isDesktop = useBreakpoint('md', 'up');
  const rotatingPlaceholder = useRotatingPlaceholder(
    isTooltipEnabled ? normalizedPlaceholders : [],
    placeholder || ''
  );

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.searchBox} id="quicksearch-search-box" data-testid="quicksearch-search-box">
        <SearchIcon className={styles.icon} />
        <input
          placeholder={rotatingPlaceholder}
          className={styles.searchInput}
          aria-describedby={shouldShowTooltip && shouldShowTooltipNow ? 'quicksearch-tooltip' : undefined}
        />
      </div>
      {shouldShowTooltip && shouldShowTooltipNow ? (
        <SearchTooltip
          id="quicksearch-tooltip"
          title={tooltipTitle}
          body={tooltipBody}
          arrow="up"
          arrowOffset={isDesktop ? '40%' : '10%'}
          className={styles.tooltipWrapper}
        />
      ) : null}
    </div>
  );
};
